import { useTranslation } from 'react-i18next'
import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'
import { LIMITED_OFFER_COUNTDOWN_SECONDS, formatOfferCountdown } from './limitedOfferConfig'
import { useOfferCountdown } from './useOfferCountdown'

const Badge = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '7px 14px',
  borderRadius: '360px',
  background: '#FFF0F5',
})

const Label = styled('span', {
  fontFamily: lightTheme.typography.Small14Semibold.fontFamily,
  fontSize: '13px',
  fontWeight: 600,
  color: lightTheme.colors.pink,
  // Digits keep a fixed width so the label does not reflow every second.
  fontVariantNumeric: 'tabular-nums',
})

/** Inline glyph until the design system has a timer icon. */
function ClockGlyph() {
  const stroke = lightTheme.colors.pink
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8.6" r="5.9" stroke={stroke} strokeWidth="1.4" />
      <path d="M8 5.4v3.2l2.1 1.5" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.2 1.6h3.6" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  )
}

/** Separate component so the per-second tick re-renders only the badge. */
function LimitedOfferCountdown() {
  const { t } = useTranslation()
  const remaining = useOfferCountdown(LIMITED_OFFER_COUNTDOWN_SECONDS)

  return (
    // role=timer is never announced on its own (implicit aria-live off), so the
    // per-second tick stays quiet; screen readers read it on demand.
    <Badge role="timer">
      <ClockGlyph />
      <Label>{t('Offer ends in %@', { arg: formatOfferCountdown(remaining) })}</Label>
    </Badge>
  )
}

export default LimitedOfferCountdown
